/* aaa-header — dropdowns, slim sticky bar, phone menu and search for
   sections/aaa-header.liquid. */
(function () {
  var DESKTOP = '(min-width: 900px)';
  var isDesk = function () { return window.matchMedia(DESKTOP).matches; };

  function init(root) {
    if (!root || root.__aaaInit) return;
    root.__aaaInit = true;

    var main = root.querySelector('[data-aaa-main]');
    var spacer = root.querySelector('.aaa-hdr__spacer');
    var banner = root.querySelector('.aaa-hdr__banner');
    var overlay = root.querySelector('[data-aaa-overlay]');
    var mega = root.querySelector('.aaa-hdr__mega');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-aaa-dd]'));
    var openItem = null;
    var closeTimer = null;

    /* ---------- dropdowns ---------- */
    function panelFor(item) {
      var t = item.querySelector('[data-aaa-dd-trigger]');
      var id = t && t.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }
    function setOpen(item, open) {
      var t = item.querySelector('[data-aaa-dd-trigger]');
      var p = panelFor(item);
      item.classList.toggle('is-open', open);
      if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (p) p.classList.toggle('is-open', open);
      if (p && p === mega) {
        if (open) root.style.setProperty('--aaa-hdr-bottom', Math.round(main.getBoundingClientRect().bottom) + 'px');
        root.classList.toggle('is-mega-open', open);
      }
    }
    function openDd(item) {
      clearTimeout(closeTimer);
      if (openItem && openItem !== item) setOpen(openItem, false);
      setOpen(item, true);
      openItem = item;
    }
    function closeAll() {
      clearTimeout(closeTimer);
      if (openItem) setOpen(openItem, false);
      openItem = null;
      items.forEach(function (o) { o.classList.remove('is-tapped'); });
    }
    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 140);
    }

    /* Hover opens the menus only on devices that really hover. On touch devices at desktop width (iPad landscape,
       touch laptops) the first tap opens the menu and a second tap follows the link. */
    var canHover = function () { return window.matchMedia && window.matchMedia('(hover: hover)').matches; };
    items.forEach(function (item) {
      var t = item.querySelector('[data-aaa-dd-trigger]');
      var p = panelFor(item);
      var hoverOpened = false;
      item.addEventListener('mouseenter', function () { if (isDesk() && canHover()) { hoverOpened = true; openDd(item); } });
      item.addEventListener('mouseleave', function () { if (isDesk() && canHover()) { hoverOpened = false; closeSoon(); } });
      if (p && p === mega) {
        p.addEventListener('mouseenter', function () { if (isDesk() && canHover()) openDd(item); });
        p.addEventListener('mouseleave', function () { if (isDesk() && canHover()) closeSoon(); });
      }
      if (t) {
        t.addEventListener('click', function (e) {
          if (!isDesk()) return;
          if (canHover()) {
            /* mouse: hover already opened it, so a click follows the link; keyboard "click" (Enter) opens first */
            if (openItem !== item || !hoverOpened) { e.preventDefault(); openDd(item); }
            return;
          }
          /* touch: open on the first tap, follow the link on the second */
          if (!item.classList.contains('is-tapped')) {
            e.preventDefault();
            items.forEach(function (o) { o.classList.remove('is-tapped'); });
            item.classList.add('is-tapped');
            openDd(item);
          }
        });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' && p) {
            e.preventDefault();
            openDd(item);
            var first = p.querySelector('a');
            if (first) first.focus();
          }
        });
      }
    });
    if (overlay) overlay.addEventListener('click', closeAll);
    root.addEventListener('focusout', function (e) {
      if (openItem && e.relatedTarget && !openItem.contains(e.relatedTarget) && !(mega && mega.contains(e.relatedTarget))) closeAll();
    });
    document.addEventListener('click', function (e) {
      if (openItem && !root.contains(e.target)) closeAll();
    });

    /* ---------- slim sticky bar ---------- */
    var fixed = false, hidden = false, lastY = window.scrollY || 0;
    var scrollMode = root.getAttribute('data-aaa-scroll') || 'hide';
    function setHidden(h) { if (h === hidden) return; hidden = h; main.classList.toggle('is-hidden', h); }
    function onScroll() {
      /* The cart drawer pins the page (assets/aaa-cart.js), which reads as a jump to the top: ignore it. */
      if (document.documentElement.classList.contains('aaa-cart-lock')) return;
      var y = window.scrollY || 0;
      var threshold = (banner ? banner.offsetHeight : 0) + spacer.offsetHeight + 40;
      var should = y > threshold;
      if (should !== fixed) {
        fixed = should;
        if (openItem) closeAll();
        main.classList.toggle('is-fixed', fixed);
        if (!fixed) setHidden(false);
      }
      /* Phones and tablets: the fixed bar slides away while scrolling down and comes back on the first scroll up, so
         reading gets the whole screen (Jake, 2026-10-22). Desktop keeps the slim bar; setting "Header while scrolling". */
      if (fixed && scrollMode === 'hide' && !isDesk() && !(drawer && !drawer.hidden)) {
        var dy = y - lastY;
        if (dy > 6 && y > threshold + 80) setHidden(true);
        else if (dy < -6) setHidden(false);
      } else if (hidden) setHidden(false);
      lastY = y;
      document.documentElement.style.setProperty('--height-header', fixed && !hidden ? main.offsetHeight + 'px' : '0px');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* ---------- phone menu ---------- */
    var drawer = root.querySelector('[data-aaa-drawer]');
    var burger = root.querySelector('[data-aaa-drawer-open]');
    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.documentElement.classList.add('aaa-hdr-lock');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var c = drawer.querySelector('[data-aaa-drawer-close]');
      if (c) c.focus();
    }
    function closeDrawer(keepFocus) {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('aaa-hdr-lock');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 260);
      if (burger && !keepFocus) burger.focus();
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      var closeBtn = drawer.querySelector('[data-aaa-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer(); });
      var dCart = drawer.querySelector('[data-aaa-drawer-cart]');
      if (dCart) dCart.addEventListener('click', function (e) {
        try {
          if (window.Alpine && Alpine.store('xMiniCart')) {
            e.preventDefault();
            closeDrawer(true);
            Alpine.store('xModal').setActiveElement('cart-icon');
            Alpine.store('xMiniCart').openCart();
          }
        } catch (err) { /* falls through to /cart */ }
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAll(); closeDrawer(); }
    });
    window.matchMedia(DESKTOP).addEventListener('change', function (m) { if (m.matches) closeDrawer(true); else closeAll(); });

    /* ---------- search: open the theme's search popup ---------- */
    var sBtn = root.querySelector('[data-aaa-search]');
    if (sBtn) sBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeAll();
      var host = root.querySelector('.aaa-hdr__search-host');
      var open = host && host.querySelector('#SearchOpen');
      var form = host && host.querySelector('#FormSearch');
      /* second click (or the popup already open) closes it */
      if (form && !form.classList.contains('popup-hidden')) { var c = host.querySelector('#SearchClose'); if (c) c.click(); return; }
      if (open) { open.click(); return; }
      /* the theme loads the search block on the first mouseover/touch (init-run); on a direct tap it may not be there yet */
      try { window.dispatchEvent(new CustomEvent('init-run')); } catch (err) {}
      var tries = 0;
      (function wait() {
        var el = root.querySelector('.aaa-hdr__search-host #SearchOpen');
        if (el) { el.click(); return; }
        if (tries++ < 20) setTimeout(wait, 100); else window.location.href = sBtn.getAttribute('href') || '/search';
      })();
    });
    /* close the search popup on a click outside it (the host has no box of its own, so Alpine's click.away never fires) */
    document.addEventListener('click', function (e) {
      var host = root.querySelector('.aaa-hdr__search-host');
      var form = host && host.querySelector('#FormSearch');
      if (!form || form.classList.contains('popup-hidden')) return;
      if (host.contains(e.target) || (sBtn && sBtn.contains(e.target))) return;
      var c = host.querySelector('#SearchClose'); if (c) c.click();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aaa-header]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
